import React from 'react';
import Button from '@amzn/awsui-components-core/button';
import Checkbox from '@amzn/awsui-components-core/checkbox';
import Dropdown from '@amzn/awsui-components-core/dropdown';
import { ReportFilterField } from 'src/components/star-grid/components/ReportFilterField';
import { FilterDropdownHeader } from 'src/components/star-grid/components/FilterDropdownHeader';
import type { ReportStudioState } from 'src/components/star-grid/hooks/useReportStudio';
import type { useStudioPreviewFilters } from 'src/components/star-grid/hooks/useStudioPreviewFilters';
import styles from 'src/components/star-grid/components/styles/FilterDropdown.module.scss';
interface Props {
  readonly state: ReportStudioState;
  readonly filters: ReturnType<typeof useStudioPreviewFilters>;
}
export const StudioPreviewCurrencies: React.FC<Props> = ({ state, filters }) => (
  <ReportFilterField label={state.text('studioCurrencies')} controlId="studio-preview-currencies" value={filters.currencySummary}>
    <Dropdown
      open={filters.currenciesOpen}
      expandToViewport
      minWidth={240}
      maxWidth={360}
      ariaRole="dialog"
      ariaLabel={state.text('studioCurrencies')}
      onOutsideClick={filters.closeCurrencies}
      onEscape={filters.dismissCurrencies}
      header={<FilterDropdownHeader controlId="studio-preview-currencies" />}
      trigger={
        <Button
          ref={filters.currencyTrigger}
          ariaHaspopup="dialog"
          ariaExpanded={filters.currenciesOpen}
          ariaLabel={state.text('studioCurrencies')}
          nativeButtonAttributes={{ id: 'studio-preview-currencies' }}
          onClick={() => filters.setCurrenciesOpen(!filters.currenciesOpen)}
        >
          {filters.currencySummary}
        </Button>
      }
      content={
        <div className={styles.currencyGroups}>
          {filters.scenarios.map((column) => (
            <section key={column.id} className={styles.currencyGroup} aria-label={column.label || column.scenario_id}>
              <h3>{column.label || column.scenario_id}</h3>
              {filters.currencyChoices(column.currency_ids).map((currency) => (
                <Checkbox
                  key={currency.id}
                  checked={column.currency_ids.includes(currency.id)}
                  onChange={({ detail }) => filters.toggleCurrency(column, currency.id, detail.checked)}
                >
                  {currency.label}
                </Checkbox>
              ))}
            </section>
          ))}
        </div>
      }
    />
  </ReportFilterField>
);
